module.exports = __webpack_public_path__ + "static/media/edit_constraints_course_availability.7261e67a.mov";